import React from 'react'
import { Routes, Route } from 'react-router-dom'
import AllUsers from '../../pages/admin/components/AllUsers'
import MatchFriend from '../../pages/admin/components/MatchFriend'
import MyAdmin from '../../pages/admin/components/MyAdmin'
import PartenaireAccept from '../../pages/admin/components/PartenaireAccept'
import PartenaireDemand from '../../pages/admin/components/PartenaireDemand'
import ServicesDemand from '../../pages/admin/components/ServicesDemand'
import CreateAdmin from '../../pages/admin/CreateAdmin'
import Dashboard from '../../pages/admin/dashboard'
import Signin from '../../pages/auth/signin'
import Signup from '../../pages/auth/signup'
import Home from '../../pages/home'
import How from '../../pages/how'
import Condition from '../../pages/informations/condition'
import Politique from '../../pages/informations/politique'
import Notfound from '../../pages/notFound'
import Recrutment from '../../pages/recrutment'
import Demand from '../../pages/user/Demand'
import Profil from '../../pages/user/profile'

export default function Router() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/my.match/:town/:district" element={<MatchFriend />} />
        <Route path="/se-connecter" element={<Signin />} />
        <Route path="/inscription" element={<Signup />} />
        <Route path="/rejoindre" element={<Recrutment />} />
        <Route path="/demand" element={<Demand />} />{' '}
        <Route path="/condition" element={<Condition />} />
        <Route path="/politique" element={<Politique />} />
        <Route path="/profil" element={<Profil />} />
        <Route path="/how" element={<How />} />
        <Route path="/my.admin" element={<Dashboard />} />
        <Route path="/admin" element={<Dashboard />} />
        <Route path="/my.user" element={<AllUsers />} />
        <Route path="/my.service" element={<ServicesDemand />} />
        <Route path="/my.friend" element={<PartenaireAccept />} />
        <Route path="/my.application" element={<PartenaireDemand/>} />
        <Route path="/my.add" element={<CreateAdmin />} />
        <Route path="/my.useradmin" element={<MyAdmin />} />
        <Route path="*" element={<Notfound />} />
      </Routes>
    </div>
  )
}
